<template>
    <div class="min-h-full w-full bg-white">
        <div class="mx-auto w-full max-w-screen-2xl pb-40 px-8">
            <template v-if="state==='loading'">
                <div class="flex mt-4">
                    Loading Contract Data...
                </div>
            </template>
            <template v-else-if="state ==='noContract'">
                <div class="flex mt-4">
                    No Contract for package! - Cannot create view or edit a Cost Plan without a contract
                </div>
            </template>
            <template v-else>
                <div class="flex space-x-2">
                    <div class="flex-1">
                        <div class="sticky top-0 bg-white px-0 mb-2 z-30">
                            <!-- Some Tabs. -->
                            <div class="flex flex-1 pt-4">
                                <div class="flex-1">
                                    <div
                                        class="text-2xl font-bold text-gray-900 border-transparent rounded shadow-none px-2 py-1 -ml-2.5 mb-0">
                                        Cost Plan
                                    </div>

                                    <!-- Scope of Works -->
                                    <div class="text-sm text-gray-500">
                                        STATUS • Reference #BLAS
                                        <span>• Revision 35</span>
                                    </div>
                                </div>
                                <div class="pt-3">
                                    <!--
                                    <div
                                        class="inline-block m-1 border-0 shadow-none px-3 py-2 font-medium text-sm rounded-md focus:z-20 focus:outline-none "
                                        style="min-width: 20px;cursor: pointer"
                                        :class="mode==='contract'?'bg-blue-100 text-blue-700 focus:ring-2 focus:ring-blue-600':''"
                                    >Contract
                                    </div>
                                    -->
                                </div>
                            </div>
                            <!-- Estimate section header (if applicable). -->
                            <div
                                class="flex mt-4 border-t border-b border-gray-200 bg-gray-50 text-xs text-gray-500 font-semibold">
                                <div class="w-6 flex-shrink-0"></div>
                                <div class="w-16 border-l border-r border-gray-200 px-2 py-1">Ref</div>
                                <div class="flex-1 border-r border-gray-200 px-2 py-1">Description</div>
                                <div class="w-28 -ml-px border-r border-gray-200 px-2 py-1">Quantity</div>
                                <div class="w-6 flex-shrink-0 ml-2"></div>
                            </div>
                        </div>
                        <div v-if="mode==='contract'" :key="renderSectionsKey">
                            <!-- Listed Contract Sections. -->
                            <cost-plan-section v-for="section in costPlan.sections" :key="section.id"
                                               :cost-plan="costPlan"
                                               :section="section"
                                               :currentItem="currentItem"
                                               @toggleBuildup="toggleBuildup"
                                               :ref="'sections'"
                                               :readonly="readonly"
                                               @updated="update"
                                               :show-item-progress="showProgress"
                                               :show-omitted="showOmitted"
                                               :latest-progress-report="latestProgressReport"
                            ></cost-plan-section>
                        </div>
                    </div>
                    <div class="w-72 space-y-8 relative pt-4">
                        <div class="w-72 space-y-1 fixed">
                            <cost-plan-action-panel :user="user"
                                                    :cost-plan="costPlan"
                                                    :sections="costPlan.sections"
                                                    :editing="!readonly"
                                                    :rootVueComponent="rootVueComponent"
                            ></cost-plan-action-panel>
                            <div
                                style="overflow-y: auto; padding-right:12px; margin-top:12px; padding-top:12px; top:0px; height:calc(100vh - 250px)">
                                <cost-plan-status-panel :cost-plan="costPlan"
                                                        @toggleEditMode="toggleEditMode"></cost-plan-status-panel>
                                <cost-plan-settings-panel :show-omitted="showOmitted"
                                                          @toggleShowOmittedState="(i) => showOmitted = i"
                                                          :show-progress="showProgress"
                                                          @toggleShowProgressState="(i) => showProgress = i"
                                ></cost-plan-settings-panel>
                            </div>
                        </div>
                    </div>
                </div>
            </template>
        </div>
    </div>
</template>

<script>

import CostPlanItem from "./CostPlanItem.vue";
import CostPlanTask from "./CostPlanTask.vue";
import CostPlanActionPanel from "./CostPlanActionPanel.vue";
import UiToggle from "../../ui/UiToggle.vue";
import CostPlanSection from "./CostPlanSection.vue";
import draggable from "vuedraggable";
import {CostPlan, ProgressReport} from "@models";
import {debounce} from "lodash";
import CostPlanOperations from "./CostPlanOperations.vue";
import {resolveNumericText} from "../../../utils";
import CostPlanStatusPanel from "./CostPlanStatusPanel.vue";
import CostPlanSettingsPanel from "./CostPlanSettingsPanel.vue";
import ContractedWorksSection from "../contracted-works/ContractedWorksSection.vue";

export default {
    components: {
        ContractedWorksSection,
        CostPlanSettingsPanel,
        CostPlanStatusPanel,
        CostPlanOperations,
        CostPlanSection,
        draggable,
        UiToggle, CostPlanActionPanel, CostPlanTask, CostPlanItem
    },
    props: {
        id: String,
        packageReference: String
    },
    data() {
        return {
            costPlan: null,
            currentItem: null,
            buildup: null,
            user: {},
            viewKey: "",
            updateKey: 0,
            showProgress: false,
            showOmitted: false,
            mode: "contract",
            updateDebounced: debounce(this.updateNow, 200, {leading: true, maxWait: 1000}),
            readonly: true,
            resolveNumericText,
            state: 'loading',
            latestProgressReport: Object,
            rootVueComponent: this,
            renderSectionsKey: 1,
        };
    },
    computed: {},
    methods: {
        toggleBuildup(item) {
            this.currentItem = (this.currentItem === item.id) ? false : item.id
        },
        update(snapshot) {
            if (snapshot) {
                this.costPlan.addSnapshot();
            }
            this.updateDebounced();
        },
        async updateNow() {
            eventBus.$emit('cost-plan-saving', this.costPlan);
            await this.costPlan.save();
            eventBus.$emit('cost-plan-saved', this.costPlan);
        },
        toggleEditMode(i) {
            this.readonly = !i
        },
        async updateLatest() {
            this.latestProgressReport = await ProgressReport.latest(this.packageReference);
            this.costPlan = await CostPlan.find(this.packageReference);
        }
    },
    async mounted() {
        await this.updateLatest();
        if (this.costPlan) {
            this.state = "loaded"
        } else {
            this.state = "noContract"
        }
        $("#app-content").css("padding", 0);
    }
};
</script>
